/**
 * 组织授权实体
 */

import { useState, useEffect } from 'react';
import {
    Flex,
    Modal,
    Row,
    Col,
    message,
    Select,
    Input,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [groupsLists, setGroupsLists] = useState([]);
    const [viewULID, setViewULID] = useState(null);
    const [authULID, setAuthULID] = useState(null);
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setViewULID(null);
        setAuthULID(null);
        setDescription('');
    };

    useEffect(() => {
        if (props.open && groupsLists.length < 1) {
            /**
             * 获取用户下拉列表
             */
            $.ajax({
                url: `${CNF.api}groups?rss=list&rolename=seal`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        setGroupsLists(data.dat);
                    }
                }
            })
        }
    }, [props.open, groupsLists.length]);


    const ok = () => {
        if (!viewULID) {
            messageApi.error('可视者不能为空！');
            return;
        }
        if (!authULID) {
            messageApi.error('鉴权者不能为空！');
            return;
        }
        if (!description) {
            messageApi.error('备注不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: `${CNF.api}orgs/infos/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                action: CNF.actionName.ACCREDIT,
                view_ulid: viewULID,
                auth_ulid: authULID,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.refresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false);
        }, CNF.messageDuration * 1000))
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={500}
                title={'组织授权: ' + (props.record ? props.record.prefix : '')}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>可视者</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Select
                                allowClear
                                showSearch
                                placeholder='可视者'
                                style={{ width: '100%' }}
                                value={viewULID}
                                onChange={(value) => setViewULID(value ?? '')}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                options={(groupsLists || []).map(item => ({
                                    value: item.key,
                                    label: item.groupname,
                                    key: item.key,
                                }))}
                                notFoundContent='暂无数据'
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>鉴权者</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Select
                                allowClear
                                showSearch
                                placeholder='鉴权者'
                                style={{ width: '100%' }}
                                value={authULID}
                                onChange={(value) => setAuthULID(value ?? '')}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                options={(groupsLists || []).map(item => ({
                                    value: item.key,
                                    label: item.groupname,
                                    key: item.key,
                                }))}
                                notFoundContent='暂无数据'
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>备注</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                onChange={(e) => setDescription(e.target.value)}
                                value={description}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );

}

export default Entity